var path = 'templates/transcription/message-toast.html';
var html = "<md-toast class=message-toast ng-init=\"user = users.get(msg.uid)\"> <div class=user-info> <img class=user-avatar ng-src={{user.avatar}} style=\"\"/> <span class=name> {{user.name}} </span> </div> <div class=content> <span> {{msg.text}} </span> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/message-toast.html
// module id = 66
// module chunks = 0